import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Divider, Switch, FormControlLabel, Alert, Grid } from '@mui/material';
import { Settings, Lock, Palette, Person } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { useThemeContext } from '../../context/ThemeContext';
import api from '../../services/api';

export default function ConfigPage() {
  const { user, updateUser } = useAuth();
  const { mode, toggleTheme } = useThemeContext();
  const [profile, setProfile] = useState({ full_name: '', email: '' });
  const [password, setPassword] = useState({ current_password: '', new_password: '', confirm: '' });
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setProfile({ full_name: user?.full_name || '', email: user?.email || '' });
  }, [user]);

  const saveProfile = async () => {
    setMsg(''); setError('');
    try {
      const res = await api.put('/auth/me', profile);
      updateUser(res.data);
      setMsg('Perfil actualizado correctamente');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar');
    }
  };

  const changePassword = async () => {
    setMsg(''); setError('');
    if (password.new_password !== password.confirm) {
      setError('Las contraseñas no coinciden');
      return;
    }
    try {
      await api.post('/auth/change-password', {
        current_password: password.current_password,
        new_password: password.new_password
      });
      setPassword({ current_password: '', new_password: '', confirm: '' });
      setMsg('Contraseña cambiada correctamente');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cambiar contraseña');
    }
  };

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Person color="primary" />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Mi Perfil</Typography>
              </Box>

              {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

              <TextField fullWidth label="Nombre completo" value={profile.full_name}
                onChange={e => setProfile({ ...profile, full_name: e.target.value })} sx={{ mb: 2 }} />
              <TextField fullWidth label="Email" value={profile.email} type="email"
                onChange={e => setProfile({ ...profile, email: e.target.value })} sx={{ mb: 2 }} />
              <TextField fullWidth label="Usuario" value={user?.username || ''} disabled sx={{ mb: 2 }} />
              <TextField fullWidth label="Rol" value={user?.role || ''} disabled sx={{ mb: 2 }} />

              <Button variant="contained" onClick={saveProfile}>Guardar Perfil</Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Lock color="primary" />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Cambiar Contraseña</Typography>
              </Box>
              <TextField fullWidth type="password" label="Contraseña actual"
                value={password.current_password}
                onChange={e => setPassword({ ...password, current_password: e.target.value })} sx={{ mb: 2 }} />
              <TextField fullWidth type="password" label="Nueva contraseña"
                value={password.new_password}
                onChange={e => setPassword({ ...password, new_password: e.target.value })} sx={{ mb: 2 }} />
              <TextField fullWidth type="password" label="Confirmar nueva contraseña"
                value={password.confirm}
                onChange={e => setPassword({ ...password, confirm: e.target.value })} sx={{ mb: 2 }} />
              <Button variant="contained" onClick={changePassword}>Cambiar Contraseña</Button>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Palette color="primary" />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Tema</Typography>
              </Box>
              <FormControlLabel
                control={<Switch checked={mode === 'dark'} onChange={toggleTheme} />}
                label={mode === 'dark' ? 'Modo Oscuro' : 'Modo Claro'}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
